import './currency-range.scss';

import { bool, func, string } from 'prop-types';
import React, { Component } from 'react';

import CurrencyInput from '../CurrencyInput';

class CurrencyRange extends Component {
  constructor(props) {
    super(props);
    this.state = { min: null, max: null };
    this.onChange = this.onChange.bind(this);
  }

  onChange({ target: { value, name } }) {
    this.setState({ [name]: value }, () => {
      this.props.onChange({ min: this.state.min, max: this.state.max });
    });
  }

  render() {
    return (
      <div className="d-flex">
        <CurrencyInput
          className="mr-2"
          placeholder={this.props.placeholderMin}
          name="min"
          onChange={this.onChange}
          overrideEmptyByZero={false}
          hasPrefix={this.props.hasPrefix}
        />
        <CurrencyInput
          placeholder={this.props.placeholderMax}
          name="max"
          onChange={this.onChange}
          overrideEmptyByZero={false}
          hasPrefix={this.props.hasPrefix}
        />
      </div>
    );
  }
}

CurrencyRange.propTypes = {
  onChange: func.isRequired,
  placeholderMin: string,
  placeholderMax: string,
  hasPrefix: bool,
};

CurrencyRange.defaultProps = {
  placeholderMin: 'Min',
  placeholderMax: 'Max',
  hasPrefix: true,
};

export default CurrencyRange;
